var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09921 9.2745C8.61399 11.4143 10.8566 12.7661 13.2371 13.2046C12.9828 13.4394 12.706 13.6576 12.4068 13.8567C9.22763 15.9714 4.71653 15.0803 2.36463 11.7581C0.0239112 8.45158 0.784493 4.10033 3.94207 1.99993C4.52944 1.60921 5.15965 1.32156 5.8124 1.13247C4.94294 3.75712 5.33295 6.7795 7.09921 9.2745Z",
    stroke: "#2a323b",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.0686f09a85704fc5622d4e7c1c2d576c.svg";
export { ForwardRef as ReactComponent };